import { Injectable } from '@angular/core';
import { HttpRequest,  HttpHandler,  HttpEvent,  HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { TokenStorageService } from '../../common/services/token-storage.service';
import { SharedService } from '../../common/services/shared.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private tokenStorageService: TokenStorageService, 
    private sharedService: SharedService    
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<Object>> {
    if (request.url.includes('/auth/api/token') || request.url.includes('/auth/users/password-reset'))
    {
      return next.handle(request);
    }

    let authReq = request;
    let authToken = this.tokenStorageService.getAuthToken();
    // let authToken = '';
    if (authToken != null) {
      authReq = this.addTokenHeader(request, authToken);
    }
    return next.handle(authReq)
    .pipe(
      catchError(this.sharedService.handleError)
    );

  }

  private addTokenHeader(request: HttpRequest<any>, token: string) {
    return request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + token) });
  }  
}
